import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Home from '../views/Home.vue'
import User_Login from '../views/User_Login.vue'
//import About_Us from '../views/AboutView.vue'
import UserProfile from '../views/User_Profile.vue'
import AboutUs from '../views/About-Us.vue'
import About_Us from '../views/About_Us.vue'
import ContactUs from '../views/Contact-Us.vue'
import ThankYou from '../views/ThankYou.vue'
import TermsAndConditions from '../views/Terms_and_conditions.vue'
import TermsConditions from '../views/Terms-and-conditions.vue'

import Privacy_Policy from '../views/Privacy_Policy.vue'
import PrivacyPolicy from '../views/Privacy-Policy.vue'

import Deletion_Policy from '../views/Deletion_Policy.vue'
import DeletionPolicy from '../views/Deletion-Policy.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/user-login',
    name: 'User_Login',
    component: User_Login,
    //  meta: {
    //   requiresAuth: true,
    // }
    //  beforeEnter: isUserLoggedin

  },
  {
    // path: '/about_us',
    // name: 'About_Us',
    // component: About_Us,
    //  meta: {
    //   requiresAuth: true,
    // }
    //  beforeEnter: isUserLoggedin

  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou,
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs,
  },
  {
    path: '/about_us',
    name: 'About_Us',
    component: About_Us,
  },


  {
    path: '/user_profile',
    name: 'User_Profile',
    component: UserProfile,
  },

  {
    path: '/privacy_policy',
    name: 'Privacy_Policy',
    component: Privacy_Policy,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },

  {
    path: '/deletion_policy',
    name: 'Deletion_Policy',
    component: Deletion_Policy,
  },

  {
    path: '/deletion-policy',
    name: 'DeletionPolicy',
    component: DeletionPolicy,
  },




  {
    path: '/terms_and_conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,


  },
  {
    path: '/terms-and-conditions',
    name: 'TermsConditions',
    component: TermsConditions,


  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
